import Glide from '@glidejs/glide';
import GLightbox from 'glightbox';

/**
 *  App class
 *
 *  The App class functions a the main back-bone of the javascript used in this
 *  project.
 *
 */

const app = {
  onDocumentReady: (fn) => {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      // call on next available tick
      setTimeout(fn, 1);
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  },
};

function init() {
  document.querySelectorAll('.glide').forEach((glide) => {
    new Glide(glide).mount();
  });

  GLightbox();
}

app.onDocumentReady(init);

window.app = app;
